import React, { useState, useEffect, useRef } from "react";
import { fetchFeedDataForReels } from "../Utils/ReelsFetchFeeddata";
import { MoreButton } from "../../../../../UI-comp/ActionButtons.js";
import FriendMenuDropdown from "../../Friends/Utils/FriendMenuDropdown.js"; // Reuse dropdown component
import ReelsGridBottomLayout from "./ReelsGridBottomLayout";
import "../Styles/ReelsGridTopLayout.css";
import "../../../Styles/ua-common-styles.css";

const ReelsGridTopLayout = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedReels, setSelectedReels] = useState([]); // ⭐ Store selected reel IDs
  const moreButtonRef = useRef(null);

  // ⭐ Menu items for reel actions
  const menuItems = [
    {
      label: "🗑️ Delete Reels",
      action: () => {
        if (selectedReels.length === 0) {
          alert("Please select reels to delete");
          return;
        }
        const confirmed = window.confirm(
          `Are you sure you want to delete ${selectedReels.length} reel(s)? This action cannot be undone.`
        );
        if (confirmed) {
          console.log("Deleting reels:", selectedReels);
          alert(`Deleted ${selectedReels.length} reel(s)`);
          // TODO: Call your API to delete reels
          // deleteReels(selectedReels);
          setSelectedReels([]);
        }
      }
    },
    {
      label: "💾 Save Reels",
      action: () => {
        if (selectedReels.length === 0) {
          alert("Please select reels to save");
          return;
        }
        console.log("Saving reels:", selectedReels);
        alert(`Saved ${selectedReels.length} reel(s) to your collection`);
        // TODO: Call your API
        // saveReels(selectedReels);
        setSelectedReels([]);
      }
    },
    {
      label: "📦 Archive Reels",
      action: () => {
        if (selectedReels.length === 0) {
          alert("Please select reels to archive");
          return;
        }
        const confirmed = window.confirm(
          `Archive ${selectedReels.length} reel(s)?`
        );
        if (confirmed) {
          console.log("Archiving reels:", selectedReels);
          alert(`Archived ${selectedReels.length} reel(s)`);
          // TODO: Call your API
          // archiveReels(selectedReels);
          setSelectedReels([]);
        }
      }
    },
    {
      label: "🚨 Report Abuse",
      action: () => {
        if (selectedReels.length === 0) {
          alert("Please select reels to report");
          return;
        }
        console.log("Reporting abuse for reels:", selectedReels);
        alert(`Reporting ${selectedReels.length} reel(s) for abuse`);
        // TODO: Call your API
        // reportReelsAbuse(selectedReels);
        setSelectedReels([]);
      }
    },
    {
      label: "🚫 Block Reels",
      action: () => {
        if (selectedReels.length === 0) {
          alert("Please select reels to block");
          return;
        }
        const confirmed = window.confirm(
          `Block ${selectedReels.length} reel(s)? You won't see content from these creators.`
        );
        if (confirmed) {
          console.log("Blocking reels:", selectedReels);
          alert(`Blocked ${selectedReels.length} reel(s)`);
          // TODO: Call your API
          // blockReels(selectedReels);
          setSelectedReels([]);
        }
      }
    },
  ];

  const handleMoreOptionClick = () => {
    console.log("More button clicked, toggling menu");
    setMenuOpen((prev) => !prev);
  };

  const handleCloseMenu = () => {
    console.log("Closing menu");
    setMenuOpen(false);
  };

  // ⭐ Handle reel selection from child component
  const handleReelSelect = (newSelectedReels) => {
    setSelectedReels(newSelectedReels);
    console.log("Selected reels updated:", newSelectedReels);
  };

  // ⭐ Clear all selections
  const handleClearSelection = () => {
    setSelectedReels([]);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "90%"}}>
      {/* ⭐ UPPER SECTION - Header & Menu */}
      <div className="ua-top-container" style={{ marginTop: 20, marginBottom: 20, display: "flex", flexDirection: "row" }}>
        {/* Header with Selection Counter */}
        <div style={{width: "80%"}}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 20px",
            marginBottom: 15
          }}
        >
          <h2
            className="subpage-header"
            style={{
              margin: 0,
            }}
          >
            Reels
          </h2>
          </div>
        </div>
      <div>
          {/* Selection Counter */}
          {selectedReels.length > 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                background: "rgba(102, 126, 234, 0.2)",
                padding: "8px 16px",
                borderRadius: 20,
                border: "1px solid #667eea",
              }}
            >
              <span style={{ color: "white", fontSize: 14, fontWeight: 600 }}>
                {selectedReels.length} Selected
              </span>
              <button
                onClick={handleClearSelection}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#ff6b6b",
                  cursor: "pointer",
                  fontSize: 12,
                  fontWeight: 600,
                  padding: "4px 8px",
                  borderRadius: 4,
                  transition: "all 0.2s ease",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = "rgba(255, 107, 107, 0.2)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = "transparent";
                }}
              >
                Clear
              </button>
            </div>
          )}

          {/* More Button */}
          <div
            style={{
              position: "relative",
              border: "1px solid gray",
              borderRadius: 10,
              padding: "2px",
              marginLeft: 100
            }}
          >
            <MoreButton
              ref={moreButtonRef}
              onClick={handleMoreOptionClick}
              aria-label="More options"
              aria-expanded={menuOpen}
            />
          </div>
          </div>
      </div>

      {/* Dropdown Menu */}
      <FriendMenuDropdown
        isOpen={menuOpen}
        onClose={handleCloseMenu}
        items={menuItems}
        className="custom-dropdown"
        anchorRef={moreButtonRef}
      />

      {/* ⭐ LOWER SECTION - Reels Grid */}
      <div className="ua-bottom-container">
        <ReelsGridBottomLayout
          selectedReels={selectedReels}
          onReelSelect={handleReelSelect}
        />
      </div>

      {/* Debug Info (remove in production) */}
      {process.env.NODE_ENV === "development" && (
        <div
          style={{
            position: "fixed",
            bottom: 10,
            right: 10,
            background: "rgba(0,0,0,0.9)",
            color: "white",
            padding: 12,
            borderRadius: 8,
            fontSize: 11,
            zIndex: 10000,
            border: "1px solid rgba(255,255,255,0.2)",
            minWidth: 150,
          }}
        >
          <div style={{ fontWeight: "bold", marginBottom: 5, color: "#667eea" }}>
            Debug Panel (Reels)
          </div>
          <div>Menu: {menuOpen ? "✅ Open" : "❌ Closed"}</div>
          <div>Selected: {selectedReels.length}</div>
          <div style={{ fontSize: 10, color: "#aaa", marginTop: 3 }}>
            {selectedReels.length > 0
              ? `IDs: ${selectedReels.slice(0, 3).join(", ")}${selectedReels.length > 3 ? "..." : ""}`
              : "No reels selected"}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReelsGridTopLayout;